import React, { useEffect } from 'react';
import Header from '../../common/Header';
import Footer from '../../common/Footer';
import BlogShowcase from './BlogShowcase';
import { Box, Container, Grid } from '@mui/material';
import BlogBanner from './blogBanner';

const BlogHomePage = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header />
            <Box sx={{ backgroundColor: '#ffff', }}>
                <Grid >
                    <BlogBanner/>
                    <Container>
                    <BlogShowcase />
                    </Container>
                </Grid>
            </Box>
            <Footer />
        </>
    );
};

export default BlogHomePage;
